import moment from "@/utils/moment";

const STATES = {
  created: {
    icon: "/static/icon_order_status_alert.svg",
    translatedName: "criado"
  },
  scheduled: {
    icon: "/static/icon_order_status_alert.svg",
    translatedName: "aguardando pagamento"
  },
  requested_on_gateway: {
    icon: "/static/icon_order_status_alert.svg",
    translatedName: "criando dependências"
  },
  failed_to_create_on_gateway: {
    icon: "/static/icon_order_status_alert.svg",
    translatedName: "erro na criação de dependências"
  },
  created_on_gateway: {
    icon: "/static/icon_order_status_alert.svg",
    translatedName: "aguardando pagamento"
  },
  failed_to_request_payment: {
    icon: "/static/icon_order_status_alert.svg",
    translatedName: "erro na criação do pagamento"
  },
  payment_requested: {
    icon: "/static/icon_order_status_alert.svg",
    translatedName: "pagamento solicitado"
  },
  waiting_payment: {
    icon: "/static/icon_order_status_alert.svg",
    translatedName: "aguardando pagamento"
  },
  paid: {
    icon: "/static/icon_order_status_ok.svg",
    translatedName: "pago"
  },
  not_paid: {
    icon: "/static/icon_order_status_canceled.svg",
    translatedName: "não pago"
  },
  rebooking: {
    icon: "/static/icon_order_status_alert.svg",
    translatedName: "remarcando"
  },
  rescheduling: {
    icon: "/static/icon_order_status_alert.svg",
    translatedName: "reagendando"
  },
  provisioning: {
    icon: "/static/icon_order_status_ok.svg",
    translatedName: "em limpeza"
  },
  service_not_provided: {
    icon: "/static/icon_order_status_danger.svg",
    translatedName: "diarista não compareceu"
  },
  complete: {
    icon: "/static/icon_order_status_ok.svg",
    translatedName: "completo"
  },
  waiting_refund: {
    icon: "/static/icon_order_status_canceled.svg",
    translatedName: "cancelado"
  },
  cancelled: {
    icon: "/static/icon_order_status_canceled.svg",
    translatedName: "cancelado"
  }
};

const STATES_TO_CANCEL = [
  "scheduled",
  "requested_on_gateway",
  "created_on_gateway",
  "payment_requested",
  "waiting_payment",
  "paid",
  "rebooking",
  "not_paid"
];
const STATES_TO_RESCHEDULE = ["paid"];

const STATES_TO_ACCUSE_ABSENCE = ["paid", "provisioning"];

const STATES_TO_REQUEST_INVOICE = [
  "paid",
  "provisioning",
  "complete",
  "service_not_provided"
];
const STATES_TO_CHECKOUT = [
  "scheduled",
  "created_on_gateway",
  "payment_requested",
  "waiting_payment"
];

const STATES_TO_RATE = ["complete"];

const STATES_TO_CREATE_ON_GATEWAY = ["scheduled", "fail_to_create_on_gateway"];

const DAYS_TO_PROVE_PAYMENT = 4;

export default {
  data() {
    return {
      daysToProvePayment: DAYS_TO_PROVE_PAYMENT
    };
  },
  methods: {
    canRate(status) {
      return STATES_TO_RATE.includes(status);
    },
    canCancel(status) {
      return STATES_TO_CANCEL.includes(status);
    },
    canReschedule(status) {
      return STATES_TO_RESCHEDULE.includes(status);
    },
    canRequestInvoice(status) {
      return STATES_TO_REQUEST_INVOICE.includes(status);
    },
    canGoToCheckout(order) {
      if (this.getPendingBoleto(order.payments)) return true;
      else if (!this.haveTimeToPay(order.created_at)) return false;
      else if (this.haveValidPayment(order.payments)) return false;

      //Checking if order status is valid to create payment
      return STATES_TO_CHECKOUT.includes(order.status);
    },

    haveTimeToPay(created_at) {
      let diffTime =
        moment(created_at)
          .add(20, "minutes")
          .unix() - moment().unix();

      return diffTime > 0;
    },

    haveValidPayment(payments) {
      if (payments.length) {
        let validPayment = payments.find(
          payment => payment.status === "authorized"
        );
        return validPayment;
      }
    },

    getPendingBoleto(payments) {
      return payments.find(
        el =>
          el.status === "waiting" && el.funding_instrument.type === "boletos"
      );
    },

    mustBeCreatedOnGateway(payable) {
      return (
        payable.type === "orders" &&
        STATES_TO_CREATE_ON_GATEWAY.includes(payable.status)
      );
    },

    isAOrder(type) {
      return type === "orders";
    },

    isInPeriodOfProofPayment(startsAt) {
      let deadlineForSendingProofOfPayment = moment()
        .startOf("day")
        .businessAdd(DAYS_TO_PROVE_PAYMENT);
      startsAt = moment(startsAt).startOf("day");

      return startsAt < deadlineForSendingProofOfPayment;
    },

    hasAPendingBoleto(payments) {
      return this.getPendingBoleto(payments);
    },

    mustProvePayment(payable) {
      return (
        this.isAOrder(payable.type) &&
        this.hasAPendingBoleto(payable.payments) &&
        this.isInPeriodOfProofPayment(payable.schedule_event.starts_at)
      );
    },
    orderHasDelayed(order) {
      return (
        moment(order.schedule_event.starts_at).isBefore(moment()) &&
        STATES_TO_ACCUSE_ABSENCE.includes(order.status)
      );
    }
  },

  filters: {
    getIcon(status) {
      return STATES[status].icon;
    },

    getTranslatedName(status) {
      return STATES[status].translatedName;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/orderMixin.js